import axios from 'axios';
import { AmostraExportacao } from '@models/amostra-exportacao.model';

const cria = async (formData: FormData): Promise<AmostraExportacao[]> => {
  const res = await axios.post<AmostraExportacao[]>(
    '/amostras_exportacao',
    formData,
  );
  return res.data;
};

export default {
  cria,
};
